module.exports = __webpack_public_path__ + "img/A2.c3d8f5f0.png";